import React, { ButtonHTMLAttributes } from 'react';
import { FaDatabase } from 'react-icons/fa';

import { Container } from './styles';

type IDataLoadProps = ButtonHTMLAttributes<HTMLButtonElement>;

const DataLoad: React.FC<IDataLoadProps> = () => {
  return (
    <Container>
      Carga de Dados
      <FaDatabase size={16} />
    </Container>
  );
};

export default DataLoad;
